export default "__VITE_ASSET__CPBy9KgA__"